<template>
  <div class="content-list">
    <h2 class="content-list__title" v-html="title" v-if="content.title"></h2>
    <ul class="content-list__items">
      <li class="content-list__item" v-for="(item, index) in items" :key="`item-${index}`">
        <div v-if="!item.url">
          <span class="content-list__item__title" >{{ item.title }}</span>
          <span class="content-list__item__label">{{ item.label }}</span>
        </div>
        <a :href="item.url" class="content-list__item__link" target="_blank" v-else>
          <span class="content-list__item__title">{{ item.title }}</span>
          <div class="content-list__item__label">{{ item.label }}</div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ContentList',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    title () {
      return this.content.title
    },
    items () {
      return this.content.list
    }
  }
}
</script>

<style lang="scss">
  .content-list{
    &:not(:last-of-type){
      margin-bottom: layout("spacing");
    }

    // Title

    &__title{
      @include title;
      margin: 0;
      color: white;
      line-height: 1.2;
      margin-bottom: layout("spacing")*2;
      font-family: get($font-families, "secondary");
    }

    // Items

    &__items{
      @include no-type-list;
    }

    // Item

    &__item{
      @include media("small"){
        font-size: 1.6rem;
      }
      @include media("medium-large"){
        font-size: 1.8rem;
      }

      padding-bottom: 2rem;
      color: white;

      &__link{
        @include add-transition;
        @include media("large"){
          @include add-hover-underline;
        }
        @include hover{
          color: rgba(white, 1);
        }

        margin: 0;
        display: inline-block;
        font-size: 2.5rem;
        font-family: get($font-families, 'secondary');
        color: rgba(white, 0.3);
        text-decoration: none;
        transition: color animations("duration") animations("easing");

        .content-list__item__title{
          margin-bottom: 1rem;
        }
      }

      // Title

      &__title{
        @include subtitle;
        font-family: get($font-families, 'secondary');
        display: block;
        margin: 0;
      }

      // Label

      &__label{
        @include label;
      }
    }
  }
</style>
